import * as React from 'react';
import styled from 'styled-components';

export const GalleryButton: React.FC<{
  open: boolean;
  onClick: () => void;
}> = ({ open, onClick }) => {
  return (
    <StyledIcon onClick={onClick}>
      {!open ? (
        <svg
          width="25"
          height="20"
          viewBox="0 0 30 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.0400391"
            y="0.419342"
            width="8.69806"
            height="6.76516"
            fill="white"
          />
          <rect
            x="10.6709"
            y="0.419342"
            width="8.69806"
            height="6.76516"
            fill="white"
          />
          <rect
            x="21.302"
            y="0.419342"
            width="8.69806"
            height="6.76516"
            fill="white"
          />
          <rect
            x="0.0400391"
            y="9.11743"
            width="8.69806"
            height="6.76516"
            fill="white"
          />
          <rect
            x="10.6709"
            y="9.11743"
            width="8.69806"
            height="6.76516"
            fill="white"
          />
          <rect
            x="21.302"
            y="9.11743"
            width="8.69806"
            height="6.76516"
            fill="white"
          />
          <rect
            x="0.0400391"
            y="17.8155"
            width="8.69806"
            height="6.76516"
            fill="white"
          />
          <rect
            x="10.6709"
            y="17.8155"
            width="8.69806"
            height="6.76516"
            fill="white"
          />
          <rect
            x="21.302"
            y="17.8155"
            width="8.69806"
            height="6.76516"
            fill="white"
          />
        </svg>
      ) : (
        <svg
          width="25"
          height="20"
          viewBox="0 0 30 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="30" height="25" fill="white" />
        </svg>
      )}
    </StyledIcon>
  );
};

const StyledIcon = styled.div`
  &:hover {
    cursor: pointer;
  }
`;
